import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useEffect } from 'react';
import { Collapse, Divider, Grid, IconButton, List, ListItem, ListItemButton, styled, Typography } from '@mui/material';
import { useService } from '~/services/service.base';
import { UIService } from '~/services/service.ui';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { ServiceBookCover } from '~/services/service.book.cover';
import { useStyles } from '~/views/molecules/book-contents/styles';
import { theme } from '~/theme/default';
import { ArrowUp } from '~/views/atoms/svg-icons/arrow-up';
import { ArrowBottom } from '~/views/atoms/svg-icons';
export const BookContents = ({ chapters, pagesWithoutChapter, clickBySectionHandler }) => {
    const bookCoverService = useService(ServiceBookCover);
    const { openChapterService } = bookCoverService;
    const classes = useStyles();
    const StyledListItemButton = styled(ListItemButton)({ height: 56, paddingLeft: 0, paddingRight: 0 });
    const StyledList = styled(List)({
        maxHeight: innerHeight - UIService.TOOLBAR_HEIGHT,
        overflowY: 'auto',
        paddingTop: 0,
    });
    const StyledListItem = styled(ListItem)({ minHeight: 56 });
    const ListItemSecondaryAction = observer(({ state, keyId, albumId, pageId }) => {
        return (_jsx(IconButton, { onClick: () => {
                state.handleToggle(albumId, { chapterId: keyId, pageId });
            }, children: state.openedItems[albumId]?.chapterId === keyId ? (_jsx(ArrowUp, { sx: { fontSize: '16px' } })) : (_jsx(ArrowBottom, { sx: { fontSize: '16px' } })) }));
    });
    useEffect(() => {
        if (chapters?.length) {
            const [chapter] = chapters || [];
            if (chapter && !openChapterService.openedItems[chapter.albumId]) {
                const pages = bookCoverService.getChapterPages(chapter.id);
                const [page] = pages || [];
                openChapterService.handleOpen(chapter.albumId, { chapterId: chapter.id, pageId: page.id });
            }
        }
        else if (pagesWithoutChapter?.length) {
            const [page] = bookCoverService.pagesWithoutChapter || [];
            if (page && !openChapterService.openedItems[page.albumId]) {
                openChapterService.handleOpen(page.albumId, { pageId: page.id });
            }
        }
    }, [bookCoverService, chapters, pagesWithoutChapter?.length, openChapterService]);
    const ListItemSecondaryItems = observer(({ state, keyId, children, albumId }) => {
        const isOpen = state.openedItems[albumId] && state.openedItems[albumId].chapterId === keyId;
        return (_jsx(Collapse, { in: isOpen, timeout: "auto", unmountOnExit: true, children: _jsx(List, { disablePadding: true, children: children }) }));
    });
    const StyledListItemText = styled(Typography)({ fontSize: 16 });
    const ListItemText = observer(({ state, keyId, title, albumId }) => {
        return (_jsx(StyledListItemText, { classes: {
                root: state.openedItems[albumId]?.pageId === keyId ? classes.activeItem : undefined,
            }, children: title }));
    });
    return (_jsx(Grid, { sx: { backgroundColor: theme.palette.background.paper }, flexGrow: 1, container: true, direction: "column", children: _jsxs(StyledList, { children: [_jsx(StyledListItem, { sx: { marginTop: '8px', marginBottom: '8px' }, children: _jsx(Typography, { variant: "h2", children: t('BOOK_COVER_PAGE_COVER') }) }), chapters.map((chapter, index) => {
                    const pages = bookCoverService.getChapterPages(chapter.id);
                    return (_jsxs(Fragment, { children: [_jsx(Divider, {}), _jsx(StyledListItem, { secondaryAction: _jsx(ListItemSecondaryAction, { keyId: chapter.id, albumId: chapter.albumId, pageId: openChapterService.openedItems[chapter.albumId]?.pageId || pages[0]?.id, state: openChapterService }), children: _jsx(StyledListItemButton, { children: _jsx(StyledListItemText, { variant: "button", fontWeight: 700, children: chapter.title }) }) }), _jsx(ListItemSecondaryItems, { keyId: chapter.id, albumId: chapter.albumId, state: openChapterService, children: bookCoverService.getChapterPages(chapter.id)?.map((page, index) => (_jsxs(Fragment, { children: [_jsx(Divider, {}), _jsx(StyledListItem, { children: _jsx(StyledListItemButton, { onClick: () => {
                                                    openChapterService.handleOpen(page.albumId, {
                                                        chapterId: chapter.id,
                                                        pageId: page.id,
                                                    });
                                                    clickBySectionHandler && clickBySectionHandler(page);
                                                }, children: _jsx(ListItemText, { state: openChapterService, albumId: page.albumId, keyId: page.id, title: page.title }) }) }, index)] }, index))) }, index)] }, index));
                }), pagesWithoutChapter.map((page, index) => (_jsxs(Fragment, { children: [_jsx(Divider, {}), _jsx(StyledListItem, { children: _jsx(StyledListItemButton, { onClick: () => {
                                    openChapterService.handleOpen(page.albumId, { pageId: page.id });
                                    clickBySectionHandler && clickBySectionHandler(page);
                                }, children: _jsx(ListItemText, { state: openChapterService, albumId: page.albumId, keyId: page.id, title: page.title }) }) }, index)] }, index)))] }) }));
};
